import { render, staticRenderFns } from "./ImageSizeFilterChip.vue?vue&type=template&id=712cc2ca&"
import script from "./ImageSizeFilterChip.vue?vue&type=script&lang=js&"
export * from "./ImageSizeFilterChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports